(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["eaterz-variant-prices"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(cents) {
      var n = Math.round(cents / 100);
      return '$' + n.toLocaleString('es-MX');
    }
    function init(root) {
      var box = root.querySelector('.eaterz-vprices');
      if (!box) return;
      var data;
      try { data = JSON.parse(box.querySelector('.eaterz-vprices__data').textContent); } catch (e) { return; }
      if (!data || !data.length) return;
      var unit = box.dataset.unit || 'bolsa';
      var accent = box.dataset.accent; if (accent) box.style.setProperty('--eaterz-vp-accent', accent);
      var details = box.closest('.product-details') || document;
      var byOpt = {}; data.forEach(function (v) { byOpt[v.o] = v; v.n = parseInt(String(v.o).replace(/[^0-9]/g, ''), 10) || 0; v.u = v.n ? v.p / v.n : 0; });
      var bestU = Math.min.apply(null, data.filter(function (v) { return v.u > 0; }).map(function (v) { return v.u; }));
      var distinct = data.filter(function (v) { return v.u > 0; }).some(function (v) { return v.u > bestU + 1; });

      function current() {
        var r = details.querySelector('.variant-option input[type="radio"][data-current-checked="true"], .variant-option input[type="radio"]:checked');
        if (r) { var v = byOpt[r.value]; if (v) return v; }
        var sel = details.querySelector('.variant-option select');
        if (sel && byOpt[sel.value]) return byOpt[sel.value];
        var hid = details.querySelector('input[name="id"]');
        if (hid) { var id = parseInt(hid.value, 10); for (var i = 0; i < data.length; i++) if (data[i].id === id) return data[i]; }
        return data[0];
      }
      function savings() {
        var el = box._sav || (box._sav = box.querySelector('.eaterz-vprices__savings'));
        if (!el) return;
        if (box.dataset.showSavings !== 'true') { el.hidden = true; return; }
        /* Junto al precio (misma línea) si el bloque de precio está disponible */
        var pc = details.querySelector('product-price [ref="priceContainer"]');
        if (pc && el.parentNode !== pc) { el.style.setProperty('--eaterz-vp-accent', accent || '#B83A20'); pc.appendChild(el); }
        var v = current();
        if (v && v.c > v.p) {
          var pct = Math.round((v.c - v.p) / v.c * 100);
          el.textContent = (box.dataset.save || 'Ahorras') + ' ' + money(v.c - v.p) + ' (' + pct + ' %)';
          el.hidden = false;
        } else el.hidden = true;
      }
      function pills() {
        details.querySelectorAll('fieldset.variant-option--buttons').forEach(function (fs) {
          var labels = fs.querySelectorAll('.variant-option__button-label');
          var ok = false;
          labels.forEach(function (lb) {
            var inp = lb.querySelector('input'); var v = inp && byOpt[inp.value]; if (!v) return;
            ok = true;
            var line = v.a ? '<b>' + money(v.p) + '</b>' + (box.dataset.showUnit === 'true' && v.u ? ' · ' + money(v.u) + '/' + unit : '') : 'Agotado';
            var sub = lb.querySelector('.eaterz-vp');
            if (!sub) { sub = document.createElement('span'); sub.className = 'eaterz-vp'; lb.appendChild(sub); }
            if (sub.innerHTML !== line) sub.innerHTML = line;
            var isBest = distinct && v.u > 0 && v.u <= bestU + 1 && box.dataset.best;
            var tag = lb.querySelector('.eaterz-vp-best');
            if (isBest && !tag) { tag = document.createElement('span'); tag.className = 'eaterz-vp-best'; tag.textContent = box.dataset.best; lb.appendChild(tag); }
            if (!isBest && tag) tag.remove();
          });
          if (ok) fs.classList.add('eaterz-vp-ready');
        });
      }
      function run() { pills(); savings(); }
      run();
      details.addEventListener('change', function (e) { if (e.target && e.target.matches('.variant-option input, .variant-option select')) setTimeout(run, 0); });
      document.addEventListener('variant:update', function () { setTimeout(run, 50); setTimeout(run, 400); });
      new MutationObserver(function () { clearTimeout(box._t); box._t = setTimeout(run, 60); }).observe(details, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
